export default __webpack_public_path__ + "static/media/tobipartite.bd92c308.svg";